/**
 * Cart selectors
 */
import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Container state
 */
const selectCartState = state => state.cart || initialState;

/**
 * Cart details
 */
const selectCartMessage = () =>
  createSelector(
    selectCartState,
    state => state.cartMessage
  );

const selectIsSubmitting = () =>
  createSelector(
    selectCartState,
    state => state.isSubmitting
  );

export { selectCartState, selectCartMessage, selectIsSubmitting };
